module.exports = __webpack_public_path__ + "static/media/Any_Decision_IMG-Mobile.b6558beb.png";